import { useInventoryFormDataParser } from "./useInventoryFormDataParser.js";

export default useInventoryFormDataParser;
